import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  CustomInput,
  Form,
  FormGroup,
  Row } from 'reactstrap';

class PersonifySecurityKBA extends Component {
  state = {}

  render() {
    return (
      <div className="page-personify narrow">
        <Container>
          <Row className="mb-3 mt-2 align-items-center">
            <Col className="text-center">
              <h2>For your security, we need to verify your identity</h2>
              <p>Please review the below questions and select the best answers for each.</p>
            </Col>
          </Row>
          <Form>
            <Row>
              <Col md={10} className="ml-auto mr-auto">
                <Card>
                  <CardHeader className="text-left">Which of the following colleges have you attended?</CardHeader>
                  <CardBody>
                    <FormGroup className="mb-0">
                      <CustomInput type="checkbox" id="questionOne1" label="Fairmount State University" />
                      <CustomInput type="checkbox" id="questionOne2" label="Morningside College" />
                      <CustomInput type="checkbox" id="questionOne3" label="Naugatuck Valley Community College" />
                      <CustomInput type="checkbox" id="questionOne4" label="Virginia Military Institute" />
                      <CustomInput type="checkbox" id="questionOne5" label="None of the above" />
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col md={10} className="ml-auto mr-auto">
                <Card>
                  <CardHeader className="text-left">Which of the following boats or watercraft have you owned?</CardHeader>
                  <CardBody>
                    <FormGroup className="mb-0">
                      <CustomInput type="checkbox" id="questionTwo1" label="15 ft. Merrimack Bowrid" />
                      <CustomInput type="checkbox" id="questionTwo2" label="18 ft. Marada Mx2 Sport" />
                      <CustomInput type="checkbox" id="questionTwo3" label="20 ft. Brunswick Family Boat Co 2000sr" />
                      <CustomInput type="checkbox" id="questionTwo4" label="20 ft. Sunbird Skier" />
                      <CustomInput type="checkbox" id="questionTwo5" label="None of the above" />
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col md={10} className="ml-auto mr-auto">
                <Card>
                  <CardHeader className="text-left">What color is your 1992 Oldsmobile Achieva?</CardHeader>
                  <CardBody>
                    <FormGroup className="mb-0">
                      <CustomInput type="radio" name="question3" id="questionThree1" label="Black" />
                      <CustomInput type="radio" name="question3" id="questionThree2" label="Dark Blue" />
                      <CustomInput type="radio" name="question3" id="questionThree3" label="Red" />
                      <CustomInput type="radio" name="question3" id="questionThree4" label="Silver" />
                      <CustomInput type="radio" name="question3" id="questionThree5" label="I have never been associated with this vehicle" />
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col md={4} className="ml-auto mr-auto">
                <Button tag={Link} to="/personify/pending" color="personify" size="lg" className="w-100">Confirm</Button>
              </Col>
            </Row>
          </Form>
        </Container>
      </div>
    );
  }
}

export default PersonifySecurityKBA;
